import React, { FC } from "react";
import { Route, Routes } from "react-router-dom";

import NotFoundView from "../errors/NotFoundView";
import List from "./List";
import ViewServiceAccount from "./View";

const View: FC<React.PropsWithChildren<unknown>> = () => {
  return (
    <Routes>
      <Route index element={<List />} />
      <Route path=":serviceAccountId/view" element={<ViewServiceAccount />} />
      <Route path="*" element={<NotFoundView />} />
    </Routes>
  );
};

export default View;
